export enum EStatisticType {
  topBottomTopics= 'topBottomTopics',
  topBottomTeams= 'topBottomTeams',
  topBottomLeaders= 'topBottomLeaders',
  strengthWeaknesses= 'strengthWeaknesses',
}

export enum ETeamComparisonRepresentativeness {
  poor = 'poor',
  acceptable = 'acceptable',
  good = 'good'
}

export enum ETeamComparisonRiskLevel {
  high = 'high',
  potential = 'potential',
  low = 'low'
}

export enum ETeamComparisonRating {
  strong = 'strong',
  normal = 'normal',
  weak = 'weak'
}

export enum EReportType {
  team = 'team',
  executive = 'executive'
}

export enum ERecommendationVariant {
  SHOULD = 'should',
  COULD = 'could',
  EXCEL = 'excel',
  OTHER = 'other'
}

export enum ERecommendationsLevel {
  HIGH = 'high',
  MEDIUM ='medium',
  LOW = 'low',
  OTHER = 'other'
}

export const ResourcesPerPageOptions = ['10', '15', '25', '50', '75', '100'];
